module.exports = __webpack_public_path__ + "img/home_pic1.4933da76.png";